export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cost_rupee.4b0dcc64.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};